import type React from 'react';
import * as S from './styles';
import omit from 'lodash/omit';

interface VisuallyHiddenProps extends React.HTMLAttributes<HTMLElement> {
  as?: keyof JSX.IntrinsicElements;
  children?: React.ReactNode;
}

const VisuallyHidden = (props: VisuallyHiddenProps) => {
  const { as, children } = props;
  const rest = omit(props, ['as', 'children']);
  return (
    <S.VisuallyHidden as={as || 'span'} {...rest}>
      {children}
    </S.VisuallyHidden>
  );
};

export default VisuallyHidden;
